import { render, staticRenderFns } from "./GoodsOffline.vue?vue&type=template&id=48d0ed44&scoped=true"
import script from "./GoodsOffline.vue?vue&type=script&lang=js"
export * from "./GoodsOffline.vue?vue&type=script&lang=js"
import style0 from "./GoodsOffline.vue?vue&type=style&index=0&id=48d0ed44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d0ed44",
  null
  
)

export default component.exports